import { useTranslation } from '@lt/localization';
import PropTypes from 'prop-types';
import React from 'react';
import LinkPopup from '../../../components/Popup/LinkPopup';
import withMobile from '../hocs/withMobile';

const Agreement = ({ isMobile }) => {
  const width = isMobile ? '90vw' : '800px';
  const { t } = useTranslation();

  return (
    <>
      {t('commonPages.certificate.agreement.title')}{' '}
      <LinkPopup href="/articles/certificate_agreement" width={width}>
        {t('commonPages.certificate.agreement.buyAgreement')}
      </LinkPopup>
      {t('commonPages.certificate.agreement.iAgree')}
      <LinkPopup href="/articles/privacy_policy_consent" width={width}>
        {t('commonPages.certificate.agreement.personalData')}
      </LinkPopup>
      .
    </>
  );
};

Agreement.propTypes = {
  isMobile: PropTypes.bool,
};
Agreement.defaultProps = {
  isMobile: false,
};

export default withMobile(Agreement);
